import React, { useState } from 'react';
import DeCoupons from './DeCoupons';
import DeDiscounts from './DeDiscounts';

const DeOfferTabs = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="mt-4">
            <div className="px-4">
                <button className={activeTab === 0 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => setActiveTab(0)}>Discount</button>
                <button className={activeTab === 1 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => setActiveTab(1)}>Coupon</button>
            </div>
            {activeTab === 0 ? (
                <DeDiscounts key={activeTab} />
            ) : activeTab === 1 ? (
                <DeCoupons key={activeTab} />
            ): (
                <></>
            )}
        </div>
    );
};
export default DeOfferTabs;